import { useEffect, useState } from 'react';
import { AutoSave } from '@equifinance/shared';
import { useAccountContext } from '../../contexts';
import AccountStage from '../AccountStage';
import ProductsSidebar from './ProductSidebar/ProductsSidebar';
import ProductsForm from './ProductsForm';
import ProductSidebarFooter from './ProductSidebar/ProductSidebarFooter';
import useDocumentsApi, { EsisInfo } from '../../api/useDocumentsApi';
import AccountTabPage from '../Page/AccountTabPage';
import { ApplicationPageType } from '../AccountTabNav';
import { useProductLoanDetailsAutoSave } from '../../contexts/products/useProducts';

export default function ProductsPage() {
  const { id } = useAccountContext();
  const { postGenerateEsis, getEsisQuoteHistory } = useDocumentsApi();

  const [productSelected, setProductSelected] = useState<boolean>(false);
  const [esisInfos, setEsisInfos] = useState<EsisInfo[]>([]);

  const handleProductSelected = (productId: string) => {
    setProductSelected(!!productId);
  };

  const handleDownloadEsis = async (applicationId: string, productId: string) => {
    const { documentData, esisQuotes } = await postGenerateEsis(applicationId, productId);

    if (esisQuotes) {
      setEsisInfos(esisQuotes);
    }

    return documentData;
  };

  useEffect(() => {
    (async () => {
      setEsisInfos((await getEsisQuoteHistory(id)) ?? []);
    })();
  }, [id]);

  return (
    <AccountTabPage
      subHeader={<AccountStage />}
      sidebar={<ProductsSidebar productSelected={productSelected} />}
      sidebarFooter={<ProductSidebarFooter />}
      page={ApplicationPageType.PRODUCT}
    >
      <AutoSave autoSave={useProductLoanDetailsAutoSave}>
        <ProductsForm
          esisInfos={esisInfos}
          handleDownloadEsis={handleDownloadEsis}
          handleProductSelected={handleProductSelected}
        />
      </AutoSave>
    </AccountTabPage>
  );
}
